import { clubQueryKeys, customPaymentCategoryQueryFn } from "@gymflow/api";
import { CustomPaymentCategoryDTO } from "@gymflow/types";
import { infiniteQueryOptions } from "@tanstack/react-query";
import useGymflowModels from "apps/portal/src/store";
import { useContext } from "react";

import { ApiResolverContext } from "../../../providers/ApiResolverProvider/ApiResolverContext";
import { SelectInput, SelectInputProps } from "./SelectInput";

export type CustomPaymentCategorySelectInputProps =
  SelectInputProps<CustomPaymentCategoryDTO>;
export const CustomPaymentCategorySelectInput = (
  props: Omit<SelectInputProps<CustomPaymentCategoryDTO>, "dataFetchingQuery">,
) => {
  const { api } = useGymflowModels();
  const { clubId } = useContext(ApiResolverContext);

  return (
    <SelectInput
      {...(props as SelectInputProps<CustomPaymentCategoryDTO>)}
      dataFetchingQuery={() => {
        return infiniteQueryOptions({
          queryKey: clubQueryKeys.customPaymentCategory(clubId),
          queryFn: async () =>
            await customPaymentCategoryQueryFn({ clubId, api }),
          getNextPageParam: () => undefined,
          initialPageParam: undefined,
          select: (data) => {
            return {
              pageParams: data.pageParams,
              pages: data.pages.map((page) =>
                page.map((value) => ({
                  id: value.id,
                  label: value.name,
                  value: value,
                })),
              ),
            };
          },
        });
      }}
    />
  );
};
